<template>
  <div class="choiceListWrap">
    <el-select v-model="type" @change="getDeviceList">
      <el-option
        v-for="item in typeList"
        :key="item.name"
        :label="item.name"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="value"
      :disabled="type == '量测设备,用能设备,传感器'"
      style="margin-top: 10px"
      @change="resetList"
    >
      <el-option
        v-for="item in options"
        :key="item.name"
        :label="item.name"
        :value="item.name"
      >
      </el-option>
    </el-select>
    <el-input
      placeholder="请输入搜索内容"
      v-model="filterText"
      style="margin-top: 10px"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="resetList"
      ></el-button>
    </el-input>
    <div class="groupWrap">
      <el-radio-group v-model="onlineStatus" size="mini" @change="resetList">
        <el-radio-button label="全部"></el-radio-button>
        <el-radio-button label="只看在线"></el-radio-button>
        <el-radio-button label="只看离线"></el-radio-button>
      </el-radio-group>
      <p>
        共 <span>{{ statistics }}</span> 条
      </p>
    </div>

    <div class="infinite-list-wrapper" style="overflow-y: auto" ref="scrollUl">
      <ul v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li
          v-for="(v, i) in equipmentList"
          :key="i"
          @click="selectItem(v, i)"
          @dblclick="changeData"
          :class="defaultSelect == i ? 'activetItem' : ''"
        >
          {{ v.name }}
        </li>
      </ul>
      <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>
    </div>
    <div class="buttons">
      <el-button type="primary" @click="changeData" style="width: 100%"
        >确 认</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      typeList: [
        { name: "全部", value: "量测设备,用能设备,传感器" },
        { name: "量测设备", value: "量测设备" },
        { name: "用能设备", value: "用能设备" },
        { name: "传感器", value: "传感器" },
      ],
      type: "",
      options: [],
      value: "全部",
      filterText: "",
      onlineStatus: "全部",
      equipmentList: [],
      page: 0,
      hasNext: false,
      loading: false,
      defaultSelect: 0,
      activeItem: {},
      statistics: 0, //总计数
    };
  },
  computed: {
    noMore() {
      return !this.hasNext;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    async getDeviceList() {
      this.options = [{ name: "全部" }];
      this.value = "全部";
      this.page = 0;
      this.getListByType();
      let res = await api.getDeviceTypes({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        label: this.type,
      });
      if (res && res.status == 200) {
        this.options = this.options.concat(res.data);
      }
    },
    changeOnline() {},
    resetList() {
      this.page = 0;
      this.getListByType();
    },
    load() {
      if (this.hasNext) {
        this.loading = true;
        setTimeout(() => {
          this.page += 1;
          this.getListByType();
          this.loading = false;
        }, 1000);
      }
    },
    selectItem(item, index) {
      this.defaultSelect = index;
      this.activeItem = item;
    },
    async getListByType() {
      let type = this.value == "全部" ? "" : this.value;
      let parameter = {};
      if (this.onlineStatus == "全部") {
        parameter = {
          label: this.type,
          projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
            .projects[0].projectId,
          page: this.page,
          pageSize: 20,
          type: type,
          searchText: this.filterText,
        };
      } else {
        parameter = {
          label: this.type,
          projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
            .projects[0].projectId,
          page: this.page,
          pageSize: 20,
          type: type,
          searchText: this.filterText,
          active: this.onlineStatus == "只看在线" ? true : false,
        };
      }
      let res = await api.getDeviceListByType(parameter);
      console.log("列表", res);
      if (res && res.status == 200) {
        this.hasNext = res.data.hasNext;
        this.statistics = res.data.totalElements;
        if (this.page == 0) {
          this.$nextTick(() => {
            this.$refs.scrollUl.scrollTop = 0;
          });
          this.equipmentList = res.data.data;
          this.defaultSelect = 0;
          this.$emit("getSelectMenu", this.equipmentList[0]);
          this.activeItem = this.equipmentList[0];
        } else {
          this.equipmentList = this.equipmentList.concat(res.data.data);
        }
      }
    },
    changeData() {
      this.$emit("getSelectMenu", this.activeItem);
    },
  },
  created() {
    this.type = this.$route.params.type
      ? this.$route.params.type
      : "量测设备,用能设备,传感器";
    this.filterText = this.$route.query.equipmentName
      ? this.$route.query.equipmentName
      : "";
    this.getDeviceList();
  },
};
</script>

<style lang="scss" scoped>
.choiceListWrap {
  width: 93%;
  height: 94%;
  overflow: hidden;
  @include setFlexColumn;
  .groupWrap {
    @include setFlexStart;
    margin-top: 20px;
    p {
      margin-left: 10px;
      span {
        color: #28cccb;
        font-weight: bold;
      }
    }
  }
  .infinite-list-wrapper {
    height: 65%;
    margin: 20px 0;
    background: #f7f7f7;
    border: 1px solid #e7e7e7;
    border-radius: 6px;
    ul {
      width: 90%;
      margin: 0 auto;
      li {
        text-indent: 30px;
        line-height: 30px;
        margin: 10px 0;
        cursor: default;
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
      }
      li:hover {
        background: rgba(40, 204, 203, 0.5);
        color: #fff;
      }
      .activetItem {
        background: #28cccb !important;
        color: #fff;
      }
    }
    p {
      margin: 10px 0;
      text-align: center;
    }
  }
  .buttons {
    width: 55%;
    margin: 0 auto;
  }
}
</style>
